import React from 'react';
import Pagination from 'rc-pagination';

export default function Paginate({ onChange, current, total, pageSize }) {

    return (
        <>
            {total > pageSize && <Pagination
                onChange={onChange}
                current={current}
                total={total}
                pageSize={pageSize}
                showLessItems
                prevIcon={<span>&#x23F4;</span>}
                nextIcon={<span>&#x23F5;</span>}
            />}
        </>
    )
}

